import Vue from 'vue'
import Router from 'vue-router'
import Splash from './components/Splash'

//reinstate to bring back password
//import Access from './components/Access'

import Library from './components/Library'
import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.use(Router)

export default new Router({
  routes: [ 

//reinstate to bring back password
  // {path: '/access', name: 'access', component: Access},

  { path: '/home', name: 'home', component: Splash, props: true},

  
  
  { 
    path: '/view', component: Library, props: {vrMode: false}, 
     beforeEnter: (to, from, next) => {
     if (from.fullPath === '/home') {
  next()
       }
   else {
    next('/home')
   }
}
  },
  
  { 
    path: '/vr', component: Library, props: {vrMode: true}, 
     beforeEnter: (to, from, next) => {
     if (from.fullPath === '/home') {
  next()
       }
   else {
    next('/home')
   }
}
},
{path: '*', redirect: '/home'}


   ]
    
})